import { i18n } from "../../utils/i18n";

const state = {
  collapse: true,
  hideCollapse: true,
  hideOverlay: true,
  sidebarCollapse: false,
  docFramePopup: {
    visible: false,
    title: i18n.t("shared.support"),
    href: "https://docs.bizflycloud.vn",
  },
};

const getters = {
  collapse: (state) => state.collapse,
  hideCollapse: (state) => state.hideCollapse,
  hideOverlay: (state) => state.hideOverlay,
  sidebarCollapse: (state) => state.sidebarCollapse,
  docFramePopup: (state) => state.docFramePopup,
};

const mutations = {
  UPDATE_COLLAPSE(state, collapse) {
    state.collapse = collapse;
  },
  UPDATE_HIDE_COLLAPSE(state, hideCollapse) {
    state.hideCollapse = hideCollapse;
  },
  UPDATE_SIDEBAR_COLLAPSE(state, sidebarCollapse) {
    state.sidebarCollapse = sidebarCollapse;
  },
  UPDATE_HIDE_OVERLAY(state, hideOverlay) {
    state.hideOverlay = hideOverlay;
  },
  UPDATE_DOC_FRAME_POPUP(state, docFramePopup) {
    state.docFramePopup = docFramePopup;
  },
};

const actions = {
  updateCollapse({ commit }, payload) {
    commit("UPDATE_COLLAPSE", payload);
  },
  updateHideCollapse({ commit }, payload) {
    commit("UPDATE_HIDE_COLLAPSE", payload);
  },
  updateSidebarCollapse({ commit }, payload) {
    commit("UPDATE_SIDEBAR_COLLAPSE", payload);
  },
  updateHideOverlay({ commit }, payload) {
    commit("UPDATE_HIDE_OVERLAY", payload);
  },
  updateDocFramePopup({ commit }, payload) {
    commit("UPDATE_DOC_FRAME_POPUP", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
